/* eslint-disable prettier/prettier */
import React from 'react';
import { useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { ITaxData } from '../../../../../../../../redux/duck/legado/cashin/analyticData/interface/reduxInterface';
import { ITransactionData } from '../../../../../../../../redux/duck/legado/cashin/syntheticData/interface/reduxInterface';
import Cashin from '../../../../../../../../shared/components/Wrapper/Cashin';
import {
  cpfCnpjMask,
  MaskedAccount,
} from '../../../../../../../../utils/masks';
import {
  convertToPercentage,
  convertToReal,
} from '../../../../../../../../utils/values';

function ReportAnalytical() {
  const analyticContext = useSelector(
    (reducer: IReducer) => reducer.cashInAnalytic
  );

  return (
    <Cashin.ContainerCustom>
      <Cashin.TitleContainer>
        RELATÓRIO ANALÍTICO DE TARIFA DE ENTRADA
      </Cashin.TitleContainer>
      <Cashin.Default>
        <Cashin.Body>
          <Cashin.Column>
            <Cashin.SubHead color="#18A3A8">TARIFA</Cashin.SubHead>
            <Cashin.SubHead color="#18A3A8">CLIENTE</Cashin.SubHead>
            <Cashin.SubHead color="#18A3A8">CPF/CNPJ</Cashin.SubHead>
            <Cashin.SubHead color="#18A3A8">CONTA</Cashin.SubHead>
            <Cashin.SubHead color="#18A3A8">VALOR DA TARIFA</Cashin.SubHead>
            <Cashin.SubHead color="#18A3A8">TARIFA %</Cashin.SubHead>
          </Cashin.Column>

          {analyticContext.taxs.map((item: ITaxData) => (
            <Cashin.Column>
              <Cashin.Info>{item.cod_msg}</Cashin.Info>
              <Cashin.Info>{item.name_client}</Cashin.Info>
              <Cashin.Info>{cpfCnpjMask(item.document)}</Cashin.Info>
              <Cashin.Info>
                {MaskedAccount(item.account_with_digit)}
              </Cashin.Info>
              <Cashin.Info>{convertToReal(item.value)}</Cashin.Info>
              <Cashin.Info>
                <small>
                  TARIFA_PIX:{` `}
                  {item.percent_tax_pix
                    ? `${convertToPercentage(item.percent_tax_pix, 1)}%`
                    : 'n/e'}
                  <br />
                  TARIFA_TED:{` `}
                  {item.percent_tax_ted
                    ? `${convertToPercentage(item.percent_tax_ted, 1)}%`
                    : 'n/e'}
                  <br />
                  TARIFA_BOLETO:{` `}
                  {item.percent_tax_boleto
                    ? `${convertToPercentage(item.percent_tax_boleto, 1)}%`
                    : 'n/e'}
                  <br />
                  TARIFA_DOMICILIO:{` `}
                  {item.percent_tax_domicilio
                    ? `${convertToPercentage(item.percent_tax_domicilio, 1)}%`
                    : '-'}
                </small>
              </Cashin.Info>
            </Cashin.Column>
          ))}
        </Cashin.Body>
      </Cashin.Default>
    </Cashin.ContainerCustom>
  );
}

export function ReportSynthetic() {
  const SyntheticContext = useSelector(
    (reducer: IReducer) => reducer.cashInSynthetic
  );
  return (
    <Cashin.ContainerCustom>
      <Cashin.TitleContainer>
        RELATÓRIO SINTÉTICO DE TARIFA DE ENTRADA
      </Cashin.TitleContainer>
      <Cashin.Default>
        <Cashin.Body>
          <Cashin.Column>
            <Cashin.SubHead color="#18A3A8">TIPO DE TARIFA</Cashin.SubHead>
            <Cashin.SubHead color="#18A3A8">CLIENTE</Cashin.SubHead>
            <Cashin.SubHead color="#18A3A8">CPF/CNPJ</Cashin.SubHead>
            <Cashin.SubHead color="#18A3A8">CONTA</Cashin.SubHead>
            <Cashin.SubHead color="#18A3A8">VALOR DA TARIFA</Cashin.SubHead>
            <Cashin.SubHead color="#18A3A8">DESCRIÇÃO</Cashin.SubHead>
          </Cashin.Column>
          {SyntheticContext.transaction.map((trans: ITransactionData) => (
            <Cashin.Column>
              <Cashin.Info>{trans.type}</Cashin.Info>
              <Cashin.Info>{trans.name_client}</Cashin.Info>
              <Cashin.Info>{cpfCnpjMask(trans.document)}</Cashin.Info>
              <Cashin.Info>
                {MaskedAccount(trans.account_with_digit)}
              </Cashin.Info>
              <Cashin.Info>{convertToReal(trans.value)}</Cashin.Info>
              <Cashin.Info>{trans.description}</Cashin.Info>
            </Cashin.Column>
          ))}
        </Cashin.Body>
      </Cashin.Default>
    </Cashin.ContainerCustom>
  );
}

export default ReportAnalytical;
